<script>
    export let onBookClick;
    export let showGrandmotherHistory;
    export let showPhotoAlbumInfo;
    export let showInstructions;
</script>

<div class="intro-container">
    <img
        class="tarto-box"
        src="images/extra_elements/tarto.png"
        alt=""
        title="játékszabály"
        on:click={() => showInstructions()}
    />
    <img
        src="images/extra_elements/borito.png"
        class="blue-book"
        on:click={() => onBookClick()}
        title="játék"
        alt=""
    />
    <img
        class="ash-tray-img"
        src="images/extra_elements/hamutarto.png"
        alt=""
        title="fotóalbum"
        on:click={() => showPhotoAlbumInfo()}
    />
    <img
        class="grandmother-photo-img"
        src="images/extra_elements/nagymama.png"
        alt=""
        title="család"
        on:click={() => showGrandmotherHistory()}
    />
</div>

<style>
    .intro-container {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        bottom: 0;
    }
    .blue-book {
        height: 46vh;
        transform: rotate(9deg);
        margin-left: 12vh;
        cursor: pointer;
    }
    .tarto-box {
        height: 40vh;
        transform: rotate(80deg);
        cursor: pointer;

    }
    .ash-tray-img {
        position: absolute;
        top: -15vh;
        right: -15vh;
        width: 25vw;
        cursor: pointer;
    }
    .grandmother-photo-img {
        position: absolute;
        bottom: -5vh;
        left: -2vh;
        width: 23vw;
        cursor: pointer;
        transform: rotate(-22deg);
    }
</style>